<!-- FT-220 REQ-11: причины строгого режима в диалогах выдачи и приёма — одна разметка на обе стороны. -->
<template>
  <v-alert type="warning" outlined class="mt-3" data-testid="damage-control-strict">
    {{ $t(side === "arrival" ? "damage_control.strict.arrival" : "damage_control.strict.departure") }}
    <ul>
      <li v-for="line in lines" :key="line.reason" data-testid="damage-control-strict-reason">{{ $t(line.reason) }}<template v-if="line.titles.length">: {{ line.titles.join(", ") }}</template><template v-if="line.more"> {{ $t("damage_control.strict.more", { count: line.more }) }}</template></li>
    </ul>
  </v-alert>
</template>

<script>
export default {
  name: "DamageControlStrictAlert",
  props: {
    side: { type: String, required: true },
    // Строки причин из dialogMixin.damageControlReasonLines: { reason, titles, more }.
    lines: { type: Array, default: () => [] },
  },
};
</script>
